
if (!customElements.get('nova-shop-dropdown')) {
  customElements.define('nova-shop-dropdown', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const details = this.querySelector('details');
      const summary = this.querySelector('summary');
      const mobile = this.classList.contains('nova-shop-menu--mobile');
      const close = () => { details.open = false; };
      if (mobile) this.closest('header-drawer')?.addEventListener('theme:drawer:open', () => { details.open = true; }, options);
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape' && details.open) {
          event.preventDefault();
          event.stopPropagation();
          close();
          summary.focus();
        }
      }, options);
      document.addEventListener('click', event => {
        if (!mobile && !this.contains(event.target)) close();
      }, options);
      this.addEventListener('focusout', event => {
        if (!mobile && event.relatedTarget && !this.contains(event.relatedTarget)) close();
      }, options);
      this.querySelectorAll('a').forEach(link => link.addEventListener('click', close, options));
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
